import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { EvBasketComponent } from './components/ev-basket/ev-basket.component';
import { EvContributeComponent } from './components/ev-contribute/ev-contribute.component';
import { EvExportComponent } from './components/ev-export/ev-export.component';
import { EvFilterComponent } from './components/ev-filter/ev-filter.component';
import { EvLayersComponent } from './components/ev-layers/ev-layers.component';
import { EvMapComponent } from './components/ev-map/ev-map.component';
import { EvSearchComponent } from './components/ev-search/ev-search.component';
import { EvSidebarResultsComponent } from './components/ev-sidebar-results/ev-sidebar-results.component';
import { EvSidebarComponent } from './components/ev-sidebar/ev-sidebar.component';
import { EVSidebarService } from './components/ev-sidebar/ev-sidebar.service';
import { SidebarMode } from './components/ev-sidebar/ev-sidebarMode.enum';
import { EVPanelsService } from './services/panels.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    EvSidebarComponent,
    EvContributeComponent,
    EvLayersComponent,
    EvSearchComponent,
    EvFilterComponent,
    EvExportComponent,
    EvMapComponent,
    EvBasketComponent,
    EvSidebarResultsComponent,
  ],
})
export class AppComponent implements OnInit {
  public readonly SIDEBAR_MODES = SidebarMode;
  public showHeader = true;
  public activeOption: SidebarMode = null;
  public resultsPaneActive = false;
  public subscriptions: Array<Subscription> = new Array<Subscription>();

  constructor(panelsService: EVPanelsService, sidebarService: EVSidebarService) {
    this.subscriptions.push(
      sidebarService.sidepanelModeChange().subscribe((option: SidebarMode) => {
        this.activeOption = option;
      }),
    );
    this.subscriptions.push(
      panelsService.rightPanelPositionChange().subscribe((active: boolean) => {
        this.setResultsPanel(active);
      }),
    );
  }

  ngOnInit(): void {
    //
  }

  public prepareRoute(outlet: RouterOutlet) {
    const activatedRouteData = 'animation';
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData[activatedRouteData];
  }

  public setResultsPanel(active: boolean) {
    // only update if changed
    if (active !== this.resultsPaneActive) {
      this.resultsPaneActive = active;
    }
  }
}
